import React, { useEffect, useState } from "react";
// import { useStaticQuery, graphql } from "gatsby";
import { requestGapi } from "@utils/request";
import config from "@config";

import styles from "./games.module.scss";
import Box from "@components/box";

const { imageUrl } = config;

export const tagId = "22468";
// export const tagId = "14054";

const Games = ({ onUpdate }) => {
  // const { allGamesJson } = useStaticQuery(
  //   graphql`
  //     query GamesQuery {
  //       allGamesJson {
  //         edges {
  //           node {
  //             title
  //             company
  //             # image {
  //             #   childImageSharp {
  //             #     fluid(maxWidth: 240, maxHeight: 175) {
  //             #       ...GatsbyImageSharpFluid
  //             #     }
  //             #   }
  //             # }
  //           }
  //         }
  //       }
  //     }
  //   `
  // );
  const [data, setData] = useState(null);
  useEffect(() => {
    requestGapi(
      `tags/${tagId}/originals?page[limit]=100&page[offset]=0&sort=-published-at&include=category,user`
    ).then(res => {
      const data = res?.data;
      if (data && data.length > 0) {
        setData(data);
        onUpdate(data);
      }
    });
  }, []);

  if (!data) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {data.map(o => {
        return (
          <div key={o.id} className={styles.item}>
            <Box color="red" className={styles.box}>
              <a
                href={`https://www.gcores.com/originals/${o.id}`}
                className={styles.game}
                style={{
                  backgroundImage: `url(${`${imageUrl}/${o.attributes.thumb}?x-oss-process=image/resize,limit_1,m_fill,w_248,h_116/quality,q_90`})`
                }}
              >
                <div className={styles.content}>
                  <div></div>
                  <div>. . .</div>
                  <div className={styles.btm}>
                    <p>{o.attributes.title}</p>
                    {/* <p>{o.attributes.company}</p> */}
                  </div>
                </div>
              </a>
            </Box>
          </div>
        );
      })}
    </div>
  );
};

export default Games;
